<button type="button" class="op-user-actions uk-button uk-button-text">
  <img class="op-user-actions-img" [src]="user().picture" [alt]="user().fullName" />
</button>
<div uk-dropdown="mode: click; offset: 2px; pos: bottom-right;">
  <ul class="uk-nav uk-dropdown-nav">
    <li class="uk-nav-header">{{ user().fullName }}</li>
    <li class="uk-nav-divider"></li>
    <li>
      <a class="uk-drop-close" uiSref="openPortal" [uiParams]="{ page: 'userProfile' }">Manage account</a>
    </li>
    <li>
      <a class="uk-drop-close" (click)="_tracking.privacySettings()">Manage privacy settings</a>
    </li>
    <li>
      <a class="uk-drop-close" (click)="onLogout.emit()">Logout</a>
    </li>
  </ul>
</div>
